<template>
  <div class="text-end">
    <div class="line-cart">
      <LineChart
        :chartData="modelValue.salesByDays"
        :options="modelValue.optionsNoText"
        :key="key"
      />
    </div>
    <div class="text-area right">
      <h2 class="bold-19 text-default mb-2">
        {{ $t("home.orders") }}
      </h2>
      <h2 class="bold-24 text-default">
        {{ modelValue?.total?.success?.orders }}
      </h2>
    </div>
  </div>
</template>
<script>
import { LineChart } from "vue-chart-3";

export default {
  name: "Sales",
  components: { LineChart },
  props: {
    key: Number,
    modelValue: Object,
  },
  data() {},
};
</script>
